import React from 'react';

import { APIEntityType } from '@cd3p/core/types/api';
import { Modal, Typography } from 'components';
import { useHandleApiResult } from 'hooks/useHandleApiResult';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useSensitiveData } from 'modules/sensitiveData';

import { sensitiveDataSelectors } from 'selectors';

type RequestAccessModalProps = {
  onClose: () => void;
  onSuccess?: () => void;
  requestedEntityType?: APIEntityType;
  requestedEntityId?: string | number;
};

export const RequestAccessModal: React.FC<RequestAccessModalProps> = ({
  onClose,
  onSuccess,
  requestedEntityType,
  requestedEntityId,
}) => {
  const handleApiResult = useHandleApiResult();
  const { requestSensitiveData } = useSensitiveData();
  const requestSensitiveDataPending = useSelector(
    sensitiveDataSelectors.requestSensitiveDataPending,
  );

  const { t } = useTranslation();

  const onSubmit = async () => {
    if (!requestedEntityType || !requestedEntityId) {
      return;
    }
    handleApiResult(
      () => requestSensitiveData(requestedEntityType, requestedEntityId),
      ({ showBaseToast }) => {
        showBaseToast(t('sensitiveData.toast.requestSuccess'));
        onSuccess?.();
        onClose?.();
      },
    );
  };
  return (
    <Modal
      open
      header={t('sensitiveData.requestModal.title')}
      confirmLabel={t('sensitiveData.requestModal.submitLabel')}
      onConfirm={onSubmit}
      isDisabled={requestSensitiveDataPending}
      isPending={requestSensitiveDataPending}
      onClose={onClose}
      // needed to stop propagation if modal is clicked inside material table row (from stakoverlow https://stackoverflow.com/questions/60436516/prevent-event-propagation-on-row-click-and-dialog-in-material-ui)
      onClick={e => e.stopPropagation()}
    >
      <Typography>{t('sensitiveData.requestModal.description')}</Typography>
    </Modal>
  );
};
